import $ from 'jquery';
import Swal from 'sweetalert2';

export default function() {
  updateProfile();
  updatePassword();
}

function updateProfile()
{
  $('.js-update-profile').on('submit', function(e) {
    e.preventDefault();

    if(!$(this).valid())
      return;

    if($('select[name=Gender]').val() == '-1')
    {
      Swal.fire(window.LANG.default.LABEL_WARNING, window.LANG.default.FORM_REQUIRED_GENDER, 'warning');
      return;
    }

    const formData = new FormData($(this)[0]);
    const $that = $(this);
    window.waitMe($(this), $(this).data('loading-text'));

    $.ajax({
      url: window.GLOBALS.baseLink + 'panel/profil-guncelle',
      type: 'POST',
      data: formData,
      dataType: 'json',
      contentType: false,
      processData: false,
      success: function(response) {
        if (response) {
          if (response.IsSuccess) {
            Swal.fire(response.Title, response.Message, response.Class,
            );
            if (response.Redirect) {
              setTimeout(function () {
                window.location.href = response.Redirect;
              }, 1000)
            }
            window.closeWaitMe($that);
          } else {
            Swal.fire(response.Title, response.Message, {
              icon: response.Class,
              buttons: false
            });
            window.closeWaitMe($that);
          }
        }
      }
    })
  });  
}

function updatePassword()
{
  $('.js-update-password').on('submit', function(e) {
    e.preventDefault();

    if(!$(this).valid())
      return;

    if($('input[name=Password]').val() == '' || $('input[name=NewPassword]').val() == '' || $('input[name=NewPasswordAgain]').val() == '')
    {
      Swal.fire(window.LANG.default.LABEL_WARNING, window.LANG.default.FORM_REQUIRED_GENDER, 'warning');
      return;
    }

    const formData = new FormData($(this)[0]);
    const $that = $(this);
    window.waitMe($(this), $(this).data('loading-text'));

    $.ajax({
      url: window.GLOBALS.baseLink + 'panel/sifre-guncelle',
      type: 'POST',
      data: formData,
      dataType: 'json',
      contentType: false,
      processData: false,
      success: function(response) {
        if (response) {
          if (response.IsSuccess) {
            Swal.fire(response.Title, response.Message, response.Class);
            if (response.Redirect) {
              setTimeout(function () {
                window.location.href = response.Redirect;
              }, 1000)
            }
            window.closeWaitMe($that);
          } else {
            Swal.fire(response.Title, response.Message, response.Class);
            window.closeWaitMe($that);
          }
        }
      }
    })
  });  
}